// test700
(700 && 0);
